import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Button } from '../../Action';
import { Icon } from '../../Icon';
import { TextBody } from '../../Typography';
import { useSteppedProcess } from '../context';
const StyledSummarySection = styled.div `
  display: flex;
  flex-direction: column;
`;
const SummaryList = styled.ul `
  padding: 0;
  margin: 0;
  list-style: none;
`;
const SummaryListItem = styled.li `
  ${({ theme: { space } }) => `
    display: flex;
    align-items: center;
    margin-bottom: ${space.sm};
  `}
`;
const SummaryListItemText = styled(TextBody) `
  ${({ theme: { colors } }) => `
    color: ${colors['gray-700']};
  `}
`;
const StepSummary = ({ stepIndex, step }) => {
    var _a, _b;
    const { isStepActive, stepState, setActiveStep } = useSteppedProcess();
    const { summary, unsupportedSummary: UnsupportedSummary } = step;
    const isActive = !!isStepActive(stepIndex);
    const isComplete = stepState(stepIndex) === 'complete';
    const summaryItemsLength = (summary === null || summary === void 0 ? void 0 : summary.items.length) || 0;
    const isEditButtonHidden = (_a = summary === null || summary === void 0 ? void 0 : summary.editStepButton) === null || _a === void 0 ? void 0 : _a.isHidden;
    const isCompleteAndNotActive = isComplete && !isActive;
    const showSummaryList = useMemo(() => {
        return !!summaryItemsLength && isCompleteAndNotActive;
    }, [summaryItemsLength, isActive, isComplete]);
    const showEditButton = useMemo(() => {
        return !isEditButtonHidden && isCompleteAndNotActive;
    }, [isEditButtonHidden, isActive, isComplete]);
    if (UnsupportedSummary && isCompleteAndNotActive) {
        return React.createElement(UnsupportedSummary, { stepIndex: stepIndex, step: step });
    }
    if (showSummaryList || showEditButton) {
        return (React.createElement(StyledSummarySection, null,
            showSummaryList && (React.createElement(SummaryList, null, summary === null || summary === void 0 ? void 0 : summary.items.map(summaryItem => summaryItem.custom || (React.createElement(SummaryListItem, { key: summaryItem.text, "aria-label": summaryItem.ariaLabel },
                summaryItem.icon && (React.createElement(Icon, { icon: summaryItem.icon, size: "xs", fill: "periwinkle-500", mr: "xxs", ariaHidden: true })),
                React.createElement(SummaryListItemText, { tag: "span", size: "sm", "aria-hidden": true }, summaryItem.text)))))),
            showEditButton && (React.createElement(Button, { variant: "link", ariaLabel: `Edit ${step.title.text}`, text: ((_b = summary === null || summary === void 0 ? void 0 : summary.editStepButton) === null || _b === void 0 ? void 0 : _b.customText) || 'Edit', onClick: () => setActiveStep(stepIndex), mb: "xxs" }))));
    }
    return null;
};
export { StepSummary };
//# sourceMappingURL=StepSummary.js.map